import './card-shopping.scss';

export default () => {
	jQuery( '<div class="card-shopping__quantity-button is-up"></div><div class="card-shopping__quantity-button is-down"></div>' ).insertAfter( '.js-quantity input' );
	jQuery( '.js-quantity' ).each( function () {
		let spinner = jQuery( this );
		let input = spinner.find( 'input[type="number"]' );
		let btnUp = spinner.find( '.is-up' );
		let btnDown = spinner.find( '.is-down' );
		let min = input.attr( 'min' );
		let max = input.attr( 'max' );

		btnUp.click( function () {
			let oldValue = parseFloat( input.val() );

			if ( oldValue >= max ) {
				var newVal = oldValue;
			} else {
				var newVal = oldValue + 1;
			}
			spinner.find( 'input' ).val( newVal );
			spinner.find( 'input' ).trigger( 'change' );
		} );

		btnDown.click( function () {
			let oldValue = parseFloat( input.val() );

			if ( oldValue <= min ) {
				var newVal = oldValue;
			} else {
				var newVal = oldValue - 1;
			}
			spinner.find( 'input' ).val( newVal );
			spinner.find( 'input' ).trigger( 'change' );
		} );
	} );

	const controllers = document.querySelectorAll( '[data-control]' );
	const totalPrice = document.querySelector( '.js-total-price' );
	const info = document.querySelector( '.js-order-info' );

	controllers.forEach( ( controller ) => {
		const up = controller.querySelector( '.is-up' );
		const down = controller.querySelector( '.is-down' );

		up.addEventListener( 'click', () => changeInput( controller ) );

		down.addEventListener( 'click', () => changeInput( controller ) );

		calculateTotal();
	} );

	function changeInput ( controller ) {
		const input = controller.querySelector( 'input' );
		const {
			control,
		} = controller.dataset;
		let small = document.querySelector( `[data-control="small-${control}"]` );

		if ( controller.classList.contains( 'js-control-small' ) ) {
			const big = document.querySelector( `[data-control="${control.replace( 'small-', '' )}"]` );

			big.querySelector( 'input' ).value = input.value;
			small = document.querySelector( `[data-control="${control}"]` );
		} else {
			small.querySelector( 'input' ).value = input.value;
			scrollToTarget();
		}

		if ( +input.value ) {
			small.closest( '.js-card-shopping' ).classList.remove( 'hide' );
		} else {
			small.closest( '.js-card-shopping' ).classList.add( 'hide' );
		}

		calculateTotal();
	}

	function scrollToTarget () {
		const offset = 100;

		window.scrollTo( {
			top: info.closest( 'section' ).offsetTop - offset,
			behavior: 'smooth',
		} );
	}

	function calculateTotal () {
		const finalPrice = document.querySelector( '.js-final-price textarea' );
		let total = 0;
		let text = '';

		controllers.forEach( ( controller ) => {
			if ( controller.classList.contains( 'js-control-small' ) && !controller.closest( '.js-card-shopping' ).classList.contains( 'hide' ) ) {
				const {
					title,
				} = controller.dataset;
				const price = parseFloat( controller.dataset.price.replace( ',', '.' ) );
				const qty = controller.querySelector( 'input' ).value;
				const calc = ( qty * price );

				total += calc;

				text += `
                Product: ${title}
                Price: ${price}
                Qty: ${qty}
                Sum: ${calc}
                `;
			}
		} );

		let val = total.toFixed( 2 );

		totalPrice.innerHTML = val;

		if ( finalPrice && val > 0 ) {
			finalPrice.value = `${text}
            Total: ${val}`;
			info.classList.remove( 'hide' );
		} else {
			info.classList.add( 'hide' );
		}
	}
};
